<h2 mat-dialog-title>Upload Tracks</h2>
<mat-dialog-content>

  @switch (mode) {
    @case('ready') {
      <div class="file-upload-wrapper" (drop)="onFileDrop($event)" (dragover)="onDragOver($event)">
        <input type="file"
               accept="audio/*" multiple (change)="onFileChange($event)" hidden #fileInput />

        <div class="file-dropper" (click)="triggerFileInput()">
          <img ngSrc="assets/images/image-upload.png" height="80" width="80" alt="uploaded image"/>
        </div>
      </div>

      @if(errorMessage !== '') {
        {{errorMessage}}
      }
    }
    @case ('loading') {
      <mat-progress-bar mode="determinate" [value]="loadingProcess"></mat-progress-bar>
    }

    @case ('loaded') {
      @for (item of tracks; track item.title + item.fileName; let idx = $index) {
        {{item.title}}
        <div class="track-form-container">

          <app-edit-track-component
            [genresList]="data.genresList"
            [subgenresList]="data.subgenresList"
            [track]="item"
            [(ngModel)]="models[idx]"
          ></app-edit-track-component>

        </div>
      } @empty {
        <li>There are no items.</li>
      }
    }

  }




</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="onNoClick()">Cancel</button>
  <button matButton (click)="save()">Save</button>
</mat-dialog-actions>

